module.exports = __webpack_public_path__ + "img/button-close-2.a0db89df.svg";